import { FC, useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doCheck, setCurrentCampus } from '../store/auth.slice';
import { doGetCommonCodes } from '../store/commonCode.slice';
import { doGetCampusData } from '../store/campusData.slice';
import { doGetGroups } from '../store/group.slice';
import { doGetServerDate } from '../store/serverDate.slice';
import { RootState } from '../store/rootReducer';
import Navbar from '../components/layout/Navbar';
import Sidebar from '../components/layout/Sidebar';
import Loader from '../components/Loader';
import useAuth from '../hooks/useAuth';
import AuthRouter from './AuthRouter';
import ProgramRouter from './ProgramRouter';
import CampusRouter from './CampusRouter';
import StudentRouter from './StudentRouter';
import ClassRouter from './ClassRouter';
import PaymentRouter from './PaymentRouter';
import CbtRouter from './CbtRouter';
import EntranceRouter from './EntranceRouter';
import BooksRouter from './BooksRouter';
import EventRouter from './EventRouter';
import BoardRouter from './BoardRouter';
import HomepageRouter from './HomepageRouter';
import SmsRouter from './SmsRouter';
import ArchiveRouter from './ArchiveRouter';
import MessageRouter from './MessageRouter';
import BusinessRouter from './BusinessRouter';
import StatisticsRouter from './StatisticsRouter';
import SystemRouter from './SystemRouter';
import LandingRouter from "./LandingRouter";
import ShuttleRouter from './ShuttleRouter';
import TutorRouter from './TutorRouter';
import Dashboard from '../pages/dashboard';
import usePayment from '../hooks/usePayment';
import TutorDashboard from '../pages/tutor';
import TutorClass from '../pages/tutor/class';

const Router: FC = () => {
  const dispatch = useDispatch();
  const { auth, isLogin, isLoading: isAuthLoading } = useSelector((state: RootState) => state.auth);
  useAuth();
  const location = useLocation();

  useEffect(() => {
    dispatch(doCheck());
  }, [dispatch]);

  useEffect(() => {
    if (auth.memberCode && auth.campus) {
      dispatch(doGetCommonCodes());
      dispatch(doGetCampusData());
      dispatch(doGetGroups());
      dispatch(doGetServerDate());

      const savedCurrentCampus = localStorage.getItem('currentCampus');
      if (
        savedCurrentCampus &&
        savedCurrentCampus !== 'undefined' &&
        (auth.hqYn === 'Y' || auth.campus.includes(savedCurrentCampus))
      ) {
        dispatch(setCurrentCampus(savedCurrentCampus));
      } else {
        localStorage.setItem('currentCampus', auth.campus[0]);
        dispatch(setCurrentCampus(auth.campus[0]));
      }
    }
  }, [auth]);

  const getRouters = () => {
    return (
      <>
        <ProgramRouter />
        <CampusRouter />
        <StudentRouter />
        <ClassRouter />
        <PaymentRouter />
        <CbtRouter />
        <EntranceRouter />
        <BooksRouter />
        <EventRouter />
        <BoardRouter />
        <HomepageRouter />
        <SmsRouter />
        <ArchiveRouter />
        <MessageRouter />
        <BusinessRouter />
        <StatisticsRouter />
        <SystemRouter />
        <LandingRouter />
      </>
    );
  }

  const renderRouter = () => {
    switch (auth.authGroupDiv) {
      case 'S':
        return <ShuttleRouter />;
      case 'T':
        return (
          <>
            {getRouters()}
            <Switch>
              <Route path="/" exact component={TutorDashboard} />
              <Route path='/class' exact component={TutorClass} />
            </Switch>
          </>
        );
      default:
        return (
          <>
            {getRouters()}
            <Switch>
              <Route path="/" exact component={Dashboard} />
            </Switch>
          </>
        );
    }
  };

  return (
    <>
      {
        isLogin
        ? (
            <>
              {
                (auth.authGroupDiv !== 'S' && (location.pathname.includes('assess') || location.pathname.includes('student/care'))
                  ? <TutorRouter />
                  : (
                      <div className='wrap'>
                        <Sidebar />
                        <div className="comm-container">
                          {auth.authGroupDiv !== 'S' ? (
                            <Navbar />
                          ) : null}
                          {renderRouter()}
                        </div>
                      </div>
                    )
                )
              }

            </>
          )
          : <AuthRouter />
      }
    </>
  );
};

export default Router;